<template>
  <div
    :class="[
      'flex flex-col min-h-screen',
      isHomePage ? 'bg-white' : 'bg-gray-100',
    ]"
  >
    <TheNavigation>
      <PublicNavigation />
    </TheNavigation>
    <main class="relative grow">
      <slot />
    </main>

    <ThePublicFooter />

    <ClientOnly>
      <SuperchatWidget />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const isHomePage = computed(() => useRoute().path === '/')
</script>
